import Icon from 'react-icon-base';

const IcCommunication = props => (
   <Icon viewBox='0 0 108.24 108.24' {...props}>
      <g stroke-width='3px' fill='none' stroke='currentColor'>
         <circle className='cls-1' cx='54.12' cy='54.12' r='52.62' />
         <g>
            <path
               className='cls-1'
               d='M74.52,24.87H27.7c-3.31,0-6.02,2.71-6.02,6.02v32.18c0,3.31,2.71,6.02,6.02,6.02h4.71c1.39,0,2.39,1.32,2.03,2.66l-1.84,6.72c-.37,1.34,1.16,2.4,2.29,1.59l14-10.12c.75-.54,1.66-.84,2.59-.84h23.06c3.31,0,6.02-2.71,6.02-6.02V30.9c0-3.31-2.71-6.02-6.02-6.02Z'
            />
            <line className='cls-1' x1='31.21' y1='34.75' x2='69.46' y2='34.75' />
            <line className='cls-1' x1='31.21' y1='41.55' x2='69.46' y2='41.55' />
            <line className='cls-1' x1='31.21' y1='48.34' x2='69.46' y2='48.34' />
            <line className='cls-1' x1='31.21' y1='55.13' x2='69.46' y2='55.13' />
            <line className='cls-1' x1='31.21' y1='61.92' x2='69.46' y2='61.92' />
            <path className='cls-1' d='M33.27,73.26c-2.82,0-5.34-1.47-5.99-4.1' />
            <path
               className='cls-1'
               d='M80.46,28.94c3.31,0,5.65,2.79,5.65,6.11v32.18c0,3.31-2.71,6.02-6.02,6.02h-4.71c-1.39,0-2.39,1.32-2.03,2.66l1.84,6.72c.37,1.34-1.16,2.4-2.29,1.59l-14-10.12c-.75-.54-1.66-.84-2.59-.84h-11.84'
            />
         </g>
      </g>
   </Icon>
);

export default IcCommunication;
